import { render } from "./property-poi.vue?vue&type=template&id=79d1b930"
import script from "./property-poi.js?vue&type=script&lang=js"
export * from "./property-poi.js?vue&type=script&lang=js"

import "./property-poi.vue?vue&type=style&index=0&id=79d1b930&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__